import SearchWithButton from "./SearchWithButton";

const TableHeader = ({
  title,
  count = 0,
  searchTerm,
  setSearchTerm,
  buttonLabel = "Add",
  onButtonClick,
  searchAdd = true,
}) => {
  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-4">
      <h2 className="text-lg font-semibold text-gray-700 flex items-center">
        {title}
        <span className="text-gray-400 text-sm ml-2">({count})</span>
      </h2>

      {searchAdd && (
        <SearchWithButton
          placeholder={`Search ${title.toLowerCase()}...`}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          buttonLabel={buttonLabel}
          onButtonClick={onButtonClick}
        />
      )}
    </div>
  );
};

export default TableHeader;
